module.exports = __webpack_public_path__ + "static/media/chinaUnionPay.9b59a572.svg";